import React, { useState } from 'react'
import { DataGrid } from 'Components/LifeDataGrid'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'

function ListDocuments({ fetchDocuments, documents, setSelectedRows }) {
  const siteUser = useSelector((store) => store.user)

  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)

  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchDocuments(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchDocuments(url)
  }
  const columns = [
    // { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'Nom',
      headerName: 'Nom',
      width: 120,
      editable: true,
    },
    {
      field: 'Description',
      headerName: 'Description',
      width: 200,
      editable: true,
    },
    {
      field: 'Categorie',
      headerName: 'Catégorie',
      width: 100,
      editable: true,
    },
    {
      field: 'Prix',
      headerName: 'Prix',
      width: 100,
      editable: true,
    },
    {
      field: 'Temps',
      headerName: 'Temps',
      width: 70,
      editable: true,
    },
    {
      field: 'DateObjectif',
      headerName: 'Date Objectif',
      width: 100,
    },
    {
      field: 'Duree',
      headerName: 'Durée',
      sortable: false,
      width: 70,
    },
    {
      field: 'Statut',
      headerName: 'Statut',
      sortable: false,
      width: 70,
    },
    {
      field: 'DateDeCreation',
      headerName: 'Date de création',
      sortable: false,
      width: 150,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.DateDeCreation),
    },
  ]
  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        Ma Bucketlist ({documents.count})
      </Typography>
      <DataGrid
        rows={documents.results ? documents.results : []}
        columns={columns}
        autoHeight
        pageSize={rows}
        rowCount={documents.count ? documents.count : 0}
        onPageSizeChange={handleRowsChange}
        // onRowClick={(e) => navigate(`monbien/${e.row.id}`)}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        checkboxSelection
      />
    </div>
  )
}
export default ListDocuments
